import React from 'react';
import { Translate } from 'react-localize-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../foundations/Icon';
import css from './FeaturesSection.css';

const FeaturesSection = ({
    features = [],
    pageName = '',
    numberColumns,
    featuresSectionClass = {},
    featuresCardClass = {},
}) => {
    return (
        <div className={classNames(featuresSectionClass, css.featuresSection)}>
            <div className={css.featuresHeading}>
                <Translate id={`STATIC.${pageName}.WHAT_YOU_WILL_UNLOCK`} />
            </div>
            <div className={css.featuresContainer} style={{ gridTemplateColumns: `repeat(${numberColumns}, 1fr)` }}>
                {features.map(feature => (
                    <div
                        className={classNames(featuresCardClass, css.featureCard)}
                        key={`STATIC.${pageName}.${feature.translationKey}.TITLE`}
                    >
                        <Icon
                            name={feature.iconName}
                            interactive={false}
                            className={css.iconWrapper}
                            style={{ backgroundColor: feature.iconBackgroundColor }}
                        />
                        <div className={css.featureContent}>
                            <p className={css.featureTitle}>
                                <Translate id={`STATIC.${pageName}.${feature.translationKey}.TITLE`} />
                            </p>
                            <p className={css.featureDescription}>
                                <Translate id={`STATIC.${pageName}.${feature.translationKey}.DESCRIPTION`} />
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

FeaturesSection.propTypes = {
    features: PropTypes.shape({
        iconName: PropTypes.string,
        translationKey: PropTypes.string,
        iconBackgroundColor: PropTypes.string,
    }),
    pageName: PropTypes.string,
    numberColumns: PropTypes.number,
    featuresSectionClass: PropTypes.func,
    featuresCardClass: PropTypes.func,
};

export default FeaturesSection;
